// Libraries
import React from 'react';

// Styles
import { Arrow, StyledButton } from './style'

interface ButtonPropsInterface {
  children?: any[] | any;
  arrow?: boolean;
  onClick?: any;
}

export const Button = ({ children, arrow, onClick }: ButtonPropsInterface) => {
  return (
    <StyledButton onClick={onClick}>
      {children}{arrow && <Arrow src='/button_arrow.svg'
                                 initial={{ x: 0, opacity: 1 }}
                                 animate={{ x: 5, opacity: 1 }}
                                 exit={{ x: 0, opacity: 0 }}
                                 transition={{ duration: 2, repeat: Infinity, repeatType: 'mirror' }}/>}
    </StyledButton>
  );
}